import script from "./EarnedCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./EarnedCard.vue?vue&type=script&lang=ts&setup=true"

import "./EarnedCard.vue?vue&type=style&index=0&id=6bab0572&lang=less"

const __exports__ = script;

export default __exports__